/**
 * Comment Mapper
 * Maps between CommentDto and component-level Comment types
 */

import type { CommentDto } from '../types/comment';
import type { Comment } from '@/types/job-activity';

/**
 * Map CommentDto to Comment for component consumption
 * Note: userName is not in DTO, will need to be fetched separately or passed via context
 */
export function mapCommentDtoToComment(dto: CommentDto, userName?: string): Comment {
  return {
    id: dto.id,
    jobId: dto.jobId,
    userId: dto.userId,
    userName: userName || 'Unknown User', // Should be enriched with user data
    text: dto.content,
    mentions: dto.mentions,
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
    editedAt: dto.editedAt || undefined,
  };
}

/**
 * Map array of CommentDtos to Comments
 */
export function mapCommentDtosToComments(dtos: CommentDto[]): Comment[] {
  return dtos.map(dto => mapCommentDtoToComment(dto));
}
